import React from 'react';
import { Table } from 'react-bootstrap';
import Row from "./components/Row";

const PushapiFactorTable = ({ report, onSortChange }) => {
    const rows = report.map((row, index) => (<Row {...row} key={index} />));

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th onClick={() => onSortChange('affid')}>Affid</th>
                    <th onClick={() => onSortChange('country')}>Country</th>
                    <th onClick={() => onSortChange('cost')}>Cost</th>
                    <th onClick={() => onSortChange('revenue')}>Revenue</th>
                    <th onClick={() => onSortChange('onwRevenue')}>Onw Revenue</th>
                    <th onClick={() => onSortChange('totalRevenue')}>Total Revenue</th>
                    <th onClick={() => onSortChange('roi')}>Roi</th>
                    <th onClick={() => onSortChange('factor')}>Factor</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default PushapiFactorTable;



// WEBPACK FOOTER //
// ./src/scenes/PayoutCountryFactor/components/Table/index.js